// Catálogo centralizado de módulos de navegación — fuente única para el menú
// lateral (Layout) y para el picker de permisos por usuario (Usuarios).
export const MODULOS_POR_ROL = {
  gerente: ["dashboard", "asistencia", "caja_chica", "corte_caja", "propinas", "ventas", "presupuesto", "checklist"],
  gerente_calidad: ["dashboard", "ventas", "auditoria"],
  supervisor_tiendas: ["dashboard", "asistencia", "caja_chica", "corte_caja", "propinas", "ventas", "presupuesto", "auditoria"]
};
export const ROLES_OPERATIVOS = Object.keys(MODULOS_POR_ROL);

// Grupos del menú lateral (aprobado por Ari 2026-07-20). "dashboard" no
// pertenece a ningún grupo — siempre va suelto arriba de todos.
export const NAV_GROUPS = [
  { id: "dinero", label: "Dinero", icon: "💰" },
  { id: "operacion", label: "Operación", icon: "📋" },
  { id: "punto_venta", label: "Punto de Venta", icon: "🖥️" },
  { id: "administracion", label: "Administración", icon: "⚙️" }
];

export const NAV_ITEMS = [
  { id: "dashboard",    label: "Dashboard",     icon: "📊", group: null,             roles: ["dueno", "admin", "contador", ...ROLES_OPERATIVOS] },
  { id: "caja_chica",   label: "Caja Chica",    icon: "💵", group: "dinero",         roles: ["dueno", "admin", "gerente", "supervisor_tiendas"] },
  { id: "gastos",       label: "Gastos",         icon: "🧾", group: "dinero",         roles: ["dueno", "admin", "contador"] },
  { id: "bancos",       label: "Bancos",         icon: "🏦", group: "dinero",         roles: ["dueno"], ocultoEnEmpresas: ["sushiito"] },
  { id: "propinas",     label: "Propinas",       icon: "💴", group: "dinero",         roles: ["dueno", "admin", "gerente", "supervisor_tiendas"] },
  { id: "presupuesto",  label: "Presupuesto",    icon: "📈", group: "dinero",         roles: ["dueno", "admin", "gerente", "supervisor_tiendas"] },
  { id: "reporte_semanal", label: "Junta Semanal", icon: "🗓️", group: "dinero",       roles: ["dueno"] },
  { id: "ventas",       label: "Ventas",         icon: "💰", group: "operacion",      roles: ["dueno", "admin", ...ROLES_OPERATIVOS] },
  { id: "asistencia",   label: "Asistencia",    icon: "📅", group: "operacion",      roles: ["dueno", "admin", "gerente", "supervisor_tiendas"] },
  { id: "nomina",       label: "Nómina",         icon: "💼", group: "operacion",      roles: ["dueno", "admin"] },
  { id: "tareas",       label: "Tareas",         icon: "📌", group: "operacion",      roles: ["dueno", "admin", "gerente", "supervisor_tiendas"] },
  { id: "checklist",    label: "Checklist",     icon: "✅", group: "operacion",      roles: ["dueno", "admin", "gerente"] },
  { id: "auditoria",    label: "Auditoría",     icon: "🔍", group: "operacion",      roles: ["dueno", "admin", "gerente_calidad", "supervisor_tiendas"] },
  { id: "corte_caja",   label: "Corte de Caja", icon: "🔐", group: "punto_venta",    roles: ["dueno", "admin", "gerente", "supervisor_tiendas"] },
  { id: "deposito_caja",label: "Depósito Caja", icon: "🏧", group: "punto_venta",    roles: ["dueno"] },
  { id: "empleados",    label: "Empleados",      icon: "👤", group: "administracion", roles: ["dueno", "admin"] },
  { id: "usuarios",     label: "Usuarios",       icon: "👥", group: "administracion", roles: ["dueno", "admin"] },
  { id: "reportes",     label: "Reportes",       icon: "📋", group: "administracion", roles: ["dueno", "admin", "contador"] },
  { id: "historial",    label: "Historial",      icon: "🕓", group: "administracion", roles: ["dueno", "admin"] }
];

// Módulos que ve un rol por default (antes de cualquier ajuste manual) —
// usado como plantilla de partida al dar de alta/editar un usuario.
export function modulosDefaultParaRol(rol) {
  if (MODULOS_POR_ROL[rol]) return MODULOS_POR_ROL[rol];
  return NAV_ITEMS.filter(item => item.roles.includes(rol)).map(item => item.id);
}
